module.exports = __webpack_public_path__ + "static/media/SCR007.2479d34e.mp3";